import en from '@/common/locales/en.json'
import ar from '@/common/locales/ar.json'
import tr from '@/common/locales/tr.json'
import pt from '@/common/locales/pt.json'
import bn from '@/common/locales/bn.json'
import hi from '@/common/locales/hi.json'
import ur from '@/common/locales/ur.json'
import idn from "../common/locales/in.json"
import Vue from "vue";
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    en,
    ar,
    tr,
    in: idn,
    pt,
    bn,
    hi,
    ur,
  }
})

export const setI18n = (lang) => {
  document.documentElement.lang = lang
  i18n.locale = lang
  uni.setStorageSync('language', lang)
}

export default i18n
